module.exports = __webpack_public_path__ + "img/sector_blue.b960a806.png";